import PropTypes from 'prop-types'
import React from 'react'
import {
  MenuItem
} from 'components/Menu'
import {
  ModalMenu
} from 'components/Modal'
import KanBoIcon from 'components/KanBoIcon'
import classes from '../List.module.scss'
import styled, { css } from 'styled-components'

const SelectIcon = styled(KanBoIcon)`
  &:hover {
    color: #000;
  }

  ${props => !props.selected ? css`
    &:hover {
        background-color: #fff;
      }
  ` : ''}
`

export class ListItem extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.element
    ]),
    icon: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    borderedIcon: PropTypes.bool,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    subtitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    className: PropTypes.string,
    menu: PropTypes.array,
    showMenu: PropTypes.bool,
    onMenuToggle: PropTypes.func,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    titleStyle: PropTypes.object,
    draggable: PropTypes.bool,
    selectable: PropTypes.bool,
    selected: PropTypes.bool,

    onClick: PropTypes.func,
    onSelect: PropTypes.func,
  }

  constructor (props) {
    super(props)

    this.handleMenuClick = this.handleMenuClick.bind(this)
    this.handleSelectIconClick = this.handleSelectIconClick.bind(this)
    this.renderMenu = this.renderMenu.bind(this)
  }

  handleMenuClick (event) {
    event.stopPropagation()
    event.preventDefault()
  }

  handleSelectIconClick (event) {
    event.stopPropagation()
    event.preventDefault()

    this.props.onSelect(event)
  }

  renderMenu () {
    const { menu, showMenu, onMenuToggle } = this.props

    return !!menu && (
      <ModalMenu
        show={showMenu}
        onToggle={onMenuToggle}
      >
        <span
          className={classes.menuIcon}
          onClick={this.handleMenuClick}
        >
          <KanBoIcon
            name='kanbo-16-options'
            className={classes.iconStyle}
          />
        </span>
        {Array.isArray(menu)
          ? menu.map((menuItem, index) => {
            if (React.isValidElement(menuItem)) {
              return menuItem
            }

            const { title, ...menuItemProps } = menuItem

            return (
              <MenuItem
                {...menuItemProps}
                key={index}
              >
                {title}
              </MenuItem>
            )
          })
          : menu
        }
      </ModalMenu>
    )
  }

  render () {
    const {
      children,
      icon,
      borderedIcon,
      title, // eslint-disable-line no-unused-vars
      subtitle,
      className,
      menu,
      active,
      disabled,
      titleStyle,
      draggable,
      selectable,
      selected,
      onClick,
      onSelect,

      ...props
    } = this.props

    let compClassName = 'list-group-item ' + classes.item
    if (className) compClassName += ' ' + className
    if (active) compClassName += ' active'
    if (disabled) compClassName += ' disabled'
    if (
      onClick ||
      draggable ||
      selectable
    ) compClassName += ' list-group-item-hover'
    if (draggable) compClassName += ' ' + classes.draggable

    let iconClassName = classes.iconWrapper
    if (borderedIcon) iconClassName += ' ' + classes.bordered

    return (
      <span
        {...props}
        onClick={
          onClick || (
            (selectable && onSelect)
              ? onSelect
              : undefined
          )
        }
        className={compClassName}
      >
        {selectable &&
          <span
            className={classes.iconWrapper}
            onClick={this.handleSelectIconClick}
          >
            <SelectIcon selected={selected} name={selected ? 'kanbo-16-solid-check-box-checked' : 'kanbo-16-check-box-unchecked'} />
          </span>
        }
        {icon &&
          <span className={iconClassName}>
            {icon}
          </span>
        }
        <span className={classes.titleWrapper}>
          <span className={classes.title} style={titleStyle}>{children}</span>
          {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
        </span>
        {this.renderMenu()}
      </span>
    )
  }
}

export default ListItem
